/* eslint-disable implicit-arrow-linebreak */
import React, { useContext } from 'react';
import { WelcomeCardContext } from '../../../contexts';
import { SkinnyBarSkeleton } from '../../../common/StatusUnavailableNotifications/StatusUnavailable';
import { SkinnyBar, ChallengeSkinnyBar } from './Notifications';
import { getHostCURL } from '../../../common/utils/CardUtils';
import { analytics } from '../../../core/Constants';

export const SkinnyBarNotifications = () => {
  const { isLoadingPerks, availablePerksData } = useContext(WelcomeCardContext);

  if (isLoadingPerks) {
    return <SkinnyBarSkeleton />;
  }

  if (availablePerksData?.challengeTitles?.length > 0) {
    const { challengeTitles } = availablePerksData;
    return <ChallengesCard challenge={challengeTitles[0]} />;
  }
  return <RegisterCard />;
};

const RegisterCard = () => (
  <SkinnyBar
    imgUrl="RegisteredTender.svg"
    linkURL={getHostCURL('/myaccount/payments')}
    bodyMessage="Get Easy Purchase Tracking"
    analyticsMessage={analytics.ANALYTICS_MESSAGE.Register_Tender}
    analyticsLinks={analytics.ANALYTICS_LINKS.REGISTER_CARD}
    small
  />
);

const ChallengesCard = ({ challenge }) => {
  const challengeName = challenge;
  const rhLink = '/myaccount/proXtraRewards?drawerList=challenge';
  return (
    <ChallengeSkinnyBar
      linkURL={rhLink}
      bodyMessage={challengeName}
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Offer_Challenge}
      analyticsLinks={analytics.ANALYTICS_LINKS.EARN_PROXTRA}
    />
  );
};
